export var ZnsTemplateType;
(function (ZnsTemplateType) {
    ZnsTemplateType["ORDER_CONFIRMATION"] = "ORDER_CONFIRMATION";
    ZnsTemplateType["ORDER_STATUS_UPDATE"] = "ORDER_STATUS_UPDATE";
    ZnsTemplateType["PAYMENT_CONFIRMATION"] = "PAYMENT_CONFIRMATION";
    ZnsTemplateType["TICKET_BOOKING_SUCCESS"] = "TICKET_BOOKING_SUCCESS";
    ZnsTemplateType["TICKET_REMINDER"] = "TICKET_REMINDER";
    ZnsTemplateType["PRICE_REQUEST_RECEIVED"] = "PRICE_REQUEST_RECEIVED";
    ZnsTemplateType["PRICE_REQUEST_RESPONSE"] = "PRICE_REQUEST_RESPONSE";
    ZnsTemplateType["SYSTEM_NOTIFICATION"] = "SYSTEM_NOTIFICATION";
    ZnsTemplateType["PROMOTIONAL_MESSAGE"] = "PROMOTIONAL_MESSAGE";
    ZnsTemplateType["USER_VERIFICATION"] = "USER_VERIFICATION";
    ZnsTemplateType["PASSWORD_RESET"] = "PASSWORD_RESET";
})(ZnsTemplateType || (ZnsTemplateType = {}));
//# sourceMappingURL=zns-template-type.enum.js.map